import React, { FC } from 'react'
import { handleClick } from './helpers'
import styles from './ArtAdvisory.module.scss'
import CheckIcon from 'svg/tick-redesign.svg'
import { CONTACT_US_COPY } from './helpers/constants'

const ChooseAA: FC = () => {
  return (
    <div className={styles.chooseAA}>
      <p className={`${styles.chooseAATitle} defaultTypographyH3`}>
        Why People Choose Art Advisory
      </p>
      <div className={styles.chooseAAList}>
        <div className={styles.chooseAAListCol}>
          <p className={`${styles.chooseAAItem} defaultTypographyH5`}>
            <span>
              <CheckIcon />
            </span>
            <span>Complimentary</span>
          </p>
          <p className={`${styles.chooseAAItem} defaultTypographyH5`}>
            <span>
              <CheckIcon />
            </span>
            <span>Unparalleled Selection of Original, Emerging Art</span>
          </p>
          <p className={`${styles.chooseAAItem} defaultTypographyH5`}>
            <span>
              <CheckIcon />
            </span>
            <span>Personalized Artwork Recommendations</span>
          </p>
        </div>
        <div className={styles.chooseAAListCol}>
          <p className={`${styles.chooseAAItem} defaultTypographyH5`}>
            <span>
              <CheckIcon />
            </span>
            <span>Additional Artwork Information</span>
          </p>
          <p className={`${styles.chooseAAItem} defaultTypographyH5`}>
            <span>
              <CheckIcon />
            </span>
            <span>Customer Service Assistance</span>
          </p>
          <p className={`${styles.chooseAAItem} defaultTypographyH5`}>
            <span>
              <CheckIcon />
            </span>
            <span>Custom Sizes or Commissions</span>
          </p>
        </div>
      </div>
      <button
        type='button'
        className={`${styles.servicesButton} defaultButtonGunMetal`}
        onClick={handleClick}
      >
        <p className={`${styles.buttonText} defaultTypographyCtaLarge defaultTextUppercase`}>
          {CONTACT_US_COPY}
        </p>
      </button>
    </div>
  )
}

export default ChooseAA
